import { Observable } from "rxjs";
import { HttpInterface } from "../services";
import { HttpHeaders, HttpParams } from "@angular/common/http";

export class BaseHttpServiceModel {
    //#region Constructor

    constructor(private _baseUrl: string,
        private _httpInterface: HttpInterface) { }

    //#endregion

    //#region Methods

    post<T>(url: string, data: any): Observable<T> {
        if (!url) {
            throw "url is empty";
        }

        url = this._baseUrl.concat(url);
        return this._httpInterface.post<T>(url, data);
    }

    get<T>(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<T> {
        if (!url) {
            throw "url is empty";
        }
        url = this._baseUrl.concat(url);
        return this._httpInterface.get<T>(url, params, headers);
    }

    getFile(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<Blob> {
        if (!url) {
            throw "url is empty";
        }
        url = this._baseUrl.concat(url);
        return this._httpInterface.getFile<Blob>(url, params, headers);
    }

    delete<T>(url: string, id: number): Observable<T> {
        if (!url) {
            throw "url is empty";
        }

        url = this._baseUrl.concat(url);
        return this._httpInterface.delete<T>(url, id);
    }

    //#endregion
}